import React from 'react'
import styles from '../EmpoweringIndustries/EmpoweringIndustries.module.css';
import EmpoweNavbar from './EmpoweNavbar';

const images = [
    { url: "/images/image_move1.png", alt: "Team working with AI assistant" },
    { url: "/images/image_move2.png", alt: "Developer workspace with laptop" },
    { url: "/images/image_move3.png", alt: "People collaborating on project" },
    { url: "/images/image_move4.png", alt: "Modern AI-driven call center" },
    { url: "/images/image_move1.png", alt: "Team working with AI assistant" },
    { url: "/images/image_move2.png", alt: "Developer workspace with laptop" },
    { url: "/images/image_move3.png", alt: "People collaborating on project" },
    { url: "/images/image_move4.png", alt: "Modern AI-driven call center" },
    { url: "/images/image_move1.png", alt: "Team working with AI assistant" },
    { url: "/images/image_move2.png", alt: "Developer workspace with laptop" },
    { url: "/images/image_move3.png", alt: "People collaborating on project" },
    { url: "/images/image_move4.png", alt: "Modern AI-driven call center" },
];

// Split into two uneven columns
const leftImages = images.filter((_, i) => i % 2 === 0);
const rightImages = images.filter((_, i) => i % 2 !== 0);

const EmpoweringIndustries = () => {
    return (
        <>
            <EmpoweNavbar />

            <div className={styles.containerBox}>
                <div className={styles.container}>
                    <div className={styles.LeftSection}>
                        <div className={styles.Content}>
                            <h1>Get Your AI Agent Now!</h1>
                            <p>Experience a smart, fast, and fully customizable AI agent designed to automate tasks, improve productivity, and support your workflow. Get your AI Agent now and simplify your daily operations.</p>
                        </div>
                        <div className={styles.wrapper}>
                            {/* <input
                            type="email"
                            placeholder="Enter your email"
                            className={styles.input}
                        /> */}
                            <a target="_blank" href="https://app.rexpt.in/">
                                <button className={styles.btn}>

                                    Get started for FREE</button></a>
                        </div>
                    </div>
                    <div className={styles.RightSection}>
                        <div className={styles.card}>
                            <div className={styles.scrollWrapper}>
                                <div className={styles.columns}>

                                    {/* ✅ Left Column */}
                                    <div className={styles.column}>
                                        {[...leftImages, ...leftImages].map((img, i) => (
                                            <div key={i} className={styles.leftImgBox}>
                                                <img
                                                    src={img.url}
                                                    alt={img.alt}
                                                    onError={(e) => (e.target.style.opacity = 0.3)}
                                                />
                                            </div>
                                        ))}
                                    </div>

                                    {/* ✅ Right Column */}
                                    <div className={styles.column}>
                                        {[...rightImages, ...rightImages].map((img, i) => (
                                            <div key={i} className={styles.rightImgBox}>
                                                <img
                                                    src={img.url}
                                                    alt={img.alt}
                                                    onError={(e) => (e.target.style.opacity = 0.3)}
                                                />
                                            </div>
                                        ))}
                                    </div>

                                </div>
                            </div>
                            <div className={styles.bottomOverlay}></div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}

export default EmpoweringIndustries
